import React from 'react'

import enhance from './enhancers'
import Argument from './Argument'

export function Question({ theme, question }) {
  const { question: title, arguments: claimArguments } = question

  return (
    <div className={theme.question}>
      <h1 className={theme.questionTitle}>{title}</h1>
      <div className={theme.claims}>
        {claimArguments.map(argument =>
          <Argument argument={argument} key={argument.id} />
        )}
      </div>
    </div>
  )
}

export default enhance(Question)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Question/index.js